module.exports = __webpack_public_path__ + "img/03.5cae1b7d.png";